// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Nauru */
const NR = /^(?:(?:222|55[3-9]|666|777|8\d\d|999)\d{4})$/;

export default NR;
